import { computedFrom } from 'aurelia-framework';
import { BaseDevice } from "./base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";
import { MdTooltip } from "aurelia-materialize-bridge";

import { applicationLogger } from "../../../logging/logger"; 

import { I18N } from "aurelia-i18n";

import { TemperatureScales, TemperatureConverter } from "../../../converters/temperature-value";

export class TemperatureBaseDevice extends BaseDevice {

	tooltip: MdTooltip;
	 protected i18n: I18N;

	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api);
		this.i18n = i18n;
	}

	@computedFrom('device.styles')
	get temperatureStyle(): string {
		return this.createTemperatureStyle(this.device.styles);
	}

   createTemperatureStyle(styles: any): string {
	return styles?.temperature ? `${styles.temperature}-text` : "grey-text";
}

	getTemperatureScale() {
		let scale = localStorage.getItem("temperature-scale");
		if (!scale) {
			scale = TemperatureScales.fahrenheit;
		}
		return scale;
	}

	getTemperatureSymbol(): string {
		let scale = this.getTemperatureScale();
		switch (scale) {
			case TemperatureScales.fahrenheit:
				return "°F";
			case TemperatureScales.celsius:
				return "°C";
			default:
				return "°F";
		}
	}

	convertTemperature(temperature: number) {
		let scale = this.getTemperatureScale();
		switch (scale) {
			case TemperatureScales.celsius:
				return temperature;
			case TemperatureScales.fahrenheit:
				return this.round(TemperatureConverter.toFahrenheit(temperature), 1);
			default:
				return this.round(TemperatureConverter.toFahrenheit(temperature), 1);
		}
	}

	round(value: number, precision: number): number {
		const multiplier = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}

	buildToolTip(): string {

		if (!this.device?.properties?.temperature?.value) {
			applicationLogger.debug(`First Check: The 'device' ${this.device?.name} does not have a temperature rule, cannot build tooltip.`);
			return null;
		}

		if (!this.device?.properties?.temperature?.value) {
			applicationLogger.debug(`Second Check: The 'device' ${this.device?.name} does not have a temperature rule, cannot build tooltip.`);
			return null;
		}

		const data = this.device.properties.temperature.value.split(",");
		var recommendedMinimumLabel = this.i18n.tr('recommended-minimum');
		var requiredMinimumLabel = this.i18n.tr('required-minimum');
		var requiredMaximumLabel = this.i18n.tr('required-maximum');
		var recommendedMaximumLabel = this.i18n.tr('recommended-maximum');

		var recommendedMinimum = this.convertTemperature(data[0]);
		var requiredMinimum = this.convertTemperature(data[1]);
		var requiredMaximum = this.convertTemperature(data[2]);
		var recommendedMaximum = this.convertTemperature(data[3]);

		var html = `<div class="card inner-card">`;
		html += `<div class="card-header grey-text center-block"><span class="text-center" > ${this.i18n.tr("temperature-rule-2")} (${this.getTemperatureSymbol()})</span></div>`;
		html += `<div class="card-content valign center-block">`;
		html += `${this.buildLabel(recommendedMinimumLabel, recommendedMinimum, 'label-1', 'red-label')}`;
		html += `${this.buildLabel(requiredMinimumLabel, requiredMinimum, 'label-2', 'yellow-label')}`;
		html += `${this.buildLabel(requiredMaximumLabel, requiredMaximum, 'label-3', 'yellow-label')}`;
		html += `${this.buildLabel(recommendedMaximumLabel, recommendedMaximum, 'label-4', 'red-label')}`;
		html += `</div>`;
		html += `</div>`;
		return html;
	}

	buildLabel(label: string, value: number, id: string, htmlClass: string): string {

		var html = `<div class="input-field inline">`;
		html += `<input value="${value}" readonly="true" disabled="disabled"  id ="${id}" type="text" placeholder="${label}" > `;
		html += `<label class="active ${htmlClass}" for="${id}">${label}</label>`;
		html += `</div>`;
		return html;
	}
}